import React, { useState } from 'react';
import {
  Root,
  Trigger,
  Portal,
  Content,
  Label,
  Item,
  Separator,
  Arrow,
} from '@radix-ui/react-dropdown-menu';
import { ExitIcon, PersonIcon } from '@radix-ui/react-icons';
import './ProfileDropdown.css';
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import Axios from '../../utils/Axios'
import SummaryAPI from '../../common/SummaryAPI'
import toast from 'react-hot-toast'
import AxiosToastError from '../../utils/AxiosToastError'
import { googleLogout } from '@react-oauth/google';

const DropdownMenu = {
  Root,
  Trigger,
  Portal,
  Content,
  Label,
  Item,
  Separator,
  Arrow,
};

const ProfileDropdown = ({ user }) => {
  const avatarUrl = user?.avatar || "https://www.w3schools.com/howto/img_avatar.png";
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    setPreviewImage(URL.createObjectURL(selected));
  };

  const handleUpload = (e) => {
    e.preventDefault();
    console.log('Uploading avatar:', file);
  };

  const onLogout = async()=>{
          try {
            const res = await Axios({
               ...SummaryAPI.logout
                
            })
            googleLogout();
            console.log("logout",res)
            if(res.data.success){
              toast.success(res.data.message)
              navigate("/")
            }
          } catch (error) {
            console.log(error)
            AxiosToastError(error)
          }
     }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="ProfileButton" aria-label="Profile Menu">
          <img src={avatarUrl} alt="User Avatar" className="Avatar" />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content className="DropdownMenuContent" sideOffset={5} align="end">
          <DropdownMenu.Label className="DropdownMenuLabel">Signed in as</DropdownMenu.Label>

          <DropdownMenu.Item className="DropdownMenuItem" disabled>
            <PersonIcon />
            {user?.name || "User"}
          </DropdownMenu.Item>

          <DropdownMenu.Separator className="DropdownMenuSeparator" />

          <DropdownMenu.Item asChild>
            <Link to="/dashboard/myreviews" className="DropdownMenuItem">
              My Reviews
            </Link>
          </DropdownMenu.Item>

          <DropdownMenu.Item asChild>
            <Link to="/watchlist" className="DropdownMenuItem">
              Watchlist
            </Link>
          </DropdownMenu.Item>

          {user?.university && user.university.length > 0 && (
            <DropdownMenu.Item asChild>
              <Link to="/trends" className="DropdownMenuItem">
                Movie Trends in Your University
              </Link>
            </DropdownMenu.Item>
          )}

          <DropdownMenu.Separator className="DropdownMenuSeparator" />

         
          <div className="DropdownMenuItem" style={{ padding: "0.5rem", display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <form onSubmit={handleUpload}>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                style={{ fontSize: "0.8rem" }}
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Avatar Preview"
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                />
              )}
              <button type="submit" style={{ fontSize: "0.8rem", marginTop: "0.25rem", cursor: "pointer" }}>
                Upload Avatar
              </button>
            </form>
          </div>

          <DropdownMenu.Separator className="DropdownMenuSeparator" />

          <DropdownMenu.Item className="DropdownMenuItem LogoutItem" onSelect={onLogout}>
            <ExitIcon />
            Logout
          </DropdownMenu.Item>

          <DropdownMenu.Arrow className="DropdownMenuArrow" />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default ProfileDropdown;